import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChevronLeft = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg width={8} height={14} viewBox='0 0 8 14' xmlns='http://www.w3.org/2000/svg' aria-labelledby={titleId} {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M7.02002 13.5002C6.89002 13.5002 6.77002 13.4502 6.67002 13.3502L0.27002 7.00018L6.67002 0.65018C6.87002 0.45018 7.18002 0.46018 7.38002 0.65018C7.58002 0.85018 7.57002 1.16018 7.38002 1.36018L1.70002 7.01018L7.38002 12.6602C7.58002 12.8502 7.58002 13.1702 7.38002 13.3702C7.28002 13.4702 7.15002 13.5202 7.03002 13.5202L7.02002 13.5002Z' />
  </svg>
);
export default SvgChevronLeft;
